import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=d046c43a&scoped=true"
import script from "./goodList.vue?vue&type=script&lang=js"
export * from "./goodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d046c43a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d046c43a')) {
      api.createRecord('d046c43a', component.options)
    } else {
      api.reload('d046c43a', component.options)
    }
    module.hot.accept("./goodList.vue?vue&type=template&id=d046c43a&scoped=true", function () {
      api.rerender('d046c43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/good/goodList.vue"
export default component.exports